import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DeliveryContainer from '../../containers/logistics/StationDelivery';
import Transition from './Transition';

const styles = () => ({
	dialogPaper: {
		width: '80%',
	},
	row : {
		paddingBottom : 10,
	},
	label : {
		marginRight : 10,
	},
	value : {
		fontWeight : 600,
	},
	current : {

	},
	new : {
		marginTop : 20,
	},
	section : {
		margin : '30px 0px 10px 0px',
		textAlign : 'left',
	},
	sectionHeader : {
		textTransform : 'uppercase',
		fontSize : 14,
		color : '#777',
		fontWeight : 900,
		letterSpacing : 2,
	},
});

class ViewStationDeliveryDialog extends Component {
	constructor (props) {
		super(props);
		this.state = {};
		this.handleShowHistory = this.handleShowHistory.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleVerify = this.handleVerify.bind(this);
	}

	componentDidUpdate (prevProps) {
		const { open, stationDeliveryLogs, stationDelivery, searchDeliveryLogs} = this.props;
		if (
			open &&
			prevProps.open !== open &&
			_.isEmpty(stationDeliveryLogs)
		) {
			searchDeliveryLogs({
				stationDeliveryId : stationDelivery.stationDeliveryId
			});
		}
	}

	handleClose() {
		this.props.onClose();
	}

	handleVerify(){
		const { stationDelivery, verifyDelivery } = this.props;
		verifyDelivery({
			stationDeliveryId : stationDelivery.stationDeliveryId,
			callback : err => {
				if (!err) {
					this.handleClose();
				}
			}
		});
	}

	handleShowHistory(jobResult) {
		this.setState({
			isTestDialogOpen : true,
			testJobResult : jobResult
		});
	}

	render() {
		const {
			classes,
			stationDelivery,
			//stationMap,
			authUser,
			stationDeliveryLogs
		} = this.props;

		if (!stationDelivery) {
			return null;
		}
		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);

		const logs = stationDeliveryLogs.map(r => {
			r.dateCreatedFormatted = moment(r.dateCreated).format('M/D h:mm a');
			return r;
		});

		return (
			<div>
				<Dialog
					classes={{paper : classes.dialogPaper}}
					maxWidth='md'
					open={this.props.open}
					TransitionComponent={Transition}
					onClose={this.handleClose}
				>
					<DialogTitle>
						Delivery Id {stationDelivery.stationDeliveryId}
					</DialogTitle>
					<DialogContent>
						<div className={classes.section}>
							<div className={classes.sectionHeader}>Logs</div>
						</div>
						{logs.map((log, i) => {
							return (
								<div key={i} className={classes.row}>
									<span className={classes.label}>
										<strong>{log.dateCreatedFormatted}</strong> - {log.entry}
									</span>
								</div>
							);
						})}

					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose}>
							Close
						</Button>
						{canMakeUpdates &&
						<Button variant="contained" onClick={this.handleVerify} color="primary">
							Verify delivery is complete
						</Button>
						}
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

ViewStationDeliveryDialog.propTypes = {
	open : PropTypes.bool,
	stationDelivery : PropTypes.object,
	//stationMap : PropTypes.object.isRequired,
	onClose : PropTypes.func.isRequired,
	history : PropTypes.object,
	authUser : PropTypes.object,

	verifyDelivery : PropTypes.func,
	searchDeliveryLogs : PropTypes.func.isRequired,
	stationDeliveryLogs : PropTypes.array,

	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	DeliveryContainer,
])(ViewStationDeliveryDialog);